export default "__VITE_ASSET__ChDVsQuV__"